var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.getUsers),function(user){return (_vm.id == user.id)?[_c('a',{attrs:{"href":'/#/user/' + user.id}},[_vm._v(_vm._s(user.shortened_name))])]:_vm._e()})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }